import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { Subject } from 'rxjs';

import { CurrentUser, WalletModel } from '@fantaz/shared/data-access/models';

interface OpenPanelState {
  profile: boolean;
  play: boolean;
  wallet: boolean;
}

@Component({
  selector: 'fz-navbar-user',
  templateUrl: './navbar-user.component.html',
  styleUrls: ['./navbar-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarUserComponent implements OnChanges {
  /**
   * User data
   */
  @Input()
  currentUser!: CurrentUser | null | undefined;
  @Input()
  wallet: WalletModel | null | undefined;
  @Input()
  isSticked: boolean;

  @Input()
  theme?: string;

  @Input()
  enableSwitchTheme?: boolean;

  @Output()
  logout = new EventEmitter();
  @Output()
  login: EventEmitter<void> = new EventEmitter();
  @Output()
  signUp: EventEmitter<void> = new EventEmitter();
  @Output()
  promote: EventEmitter<void> = new EventEmitter();
  @Output()
  promoteCode: EventEmitter<void> = new EventEmitter();
  @Output()
  themeChange: EventEmitter<string> = new EventEmitter();

  membershipType: string | undefined;
  unsubscribe$: Subject<void> = new Subject<void>();
  menuIconValue = 'menu';

  openPanelState: OpenPanelState = {
    profile: false,
    play: false,
    wallet: false,
  };

  profileSubmenu = [
    {
      label: 'Overview',
      link: '/profile/overview',
    },
    {
      label: 'Security',
      link: '/profile/security',
    },
    {
      label: 'Personal Info',
      link: '/profile/personal-info',
    },
    {
      label: 'Referrals',
      link: '/profile/referrals',
    },
    {
      label: 'Subscriptions',
      link: '/profile/subscriptions',
    },
    {
      label: 'Preferences',
      link: '/profile/preferences',
    },
    {
      label: 'Prizes',
      link: '/profile/prizes',
    },
    {
      label: 'Promo Codes',
      link: '/profile/promo-codes',
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currentUser?.currentValue && this.isBizAccount) {
      this.addProfileBusinessMenu();
    }
  }

  private addProfileBusinessMenu() {
    if (
      !this.profileSubmenu.some((item) => item.label === 'Business Profile')
    ) {
      this.profileSubmenu.splice(3, 0, {
        label: 'Business Info',
        link: '/profile/business-info',
      });
    }
  }

  get isLoggedIn(): boolean {
    return !!this.currentUser;
  }

  get userName(): string {
    return this.currentUser?.user?.username || '';
  }

  get userUuid(): string {
    return this.currentUser?.user?.uuid || '';
  }

  get userIcon(): string {
    const [userIcon] = this.theme?.toLowerCase().split('-') || ['dark'];
    return userIcon;
  }

  get isNotZbo(): boolean {
    return (
      !!this.currentUser && this.currentUser?.membershipInfo?.type !== 'ZBO'
    );
  }
  get isBizAccount(): boolean {
    return (
      !!this.currentUser &&
      !!this.currentUser?.user?.businessProfile?.businessName
    );
  }

  setOpenPanel(panelOpened: keyof OpenPanelState, value: boolean) {
    Object.keys(this.openPanelState).map((key) => {
      if (key === panelOpened) {
        this.openPanelState[panelOpened] = value;
      } else {
        this.openPanelState[key as keyof OpenPanelState] = false;
      }
    });
  }

  onPanelClick(e: Event) {
    e.stopPropagation();
  }

  onLogoutPress() {
    this.logout.emit();
  }

  onLogin() {
    this.login.emit();
  }
  onPromote() {
    this.promote.emit();
  }

  onSignUp() {
    this.signUp.emit();
  }

  becomeZBO(): void {
    window.location.href = `/profile/subscriptions`;
  }
  onMenuButtonPressed() {
    this.menuIconValue = 'close';
  }

  onMenuClosed() {
    this.menuIconValue = 'menu';
  }
  onPromoteCode() {
    this.promoteCode.emit();
  }
  onThemeChange(theme: string) {
    this.themeChange.emit(theme);
  }

  get userAvatarUrl(): string {
    const avatar = !this.isNotZbo ? 'zbo-light' : 'zplayer-' + this.userIcon;
    return `/shared/img/profile/${avatar}.webp`;
  }
}
